import './Button.scss';

const Button = (Props) => {
  return (
    <button
      className="formBtn"
      onClick={(event) => Props.onClick(event)}
      disabled={Props.disabled ? Props.disabled : false}
    >
      {Props.children}
    </button>
  );
};
export default Button;
